import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, BellIcon, HomeIcon, IdCardIcon, ScrollTextIcon, Trash2Icon, UserRoundIcon } from 'lucide-react';
import { espaceNav, type EspaceNavItem } from '../../data/espace';
import { useEspace } from '../../contexts/EspaceContext';
const icons: Record<EspaceNavItem['icon'], typeof HomeIcon> = {
  home: HomeIcon,
  card: IdCardIcon,
  profile: UserRoundIcon,
  bell: BellIcon,
  trash: Trash2Icon,
  request: ScrollTextIcon
};
export function EspaceSidebar() {
  const {
    pathname
  } = useLocation();
  const navigate = useNavigate();
  const {
    exitEspace
  } = useEspace();
  const activeId = espaceNav.find(item => item.to === '/my-dashboard' ? pathname === '/my-dashboard' : pathname.startsWith(item.to))?.id;
  const leave = () => {
    exitEspace();
    navigate('/');
  };
  return <aside aria-label="My dashboard navigation" className="hidden w-[268px] shrink-0 flex-col bg-ville-navy lg:flex" data-id="element-1046" data-mp="g649jqnxk82k">
      <div className="px-7 pb-6 pt-8" data-id="element-1047" data-mp="187amif2kkqi4">
        <p className="text-lg font-extrabold tracking-tight text-white" data-id="element-1048" data-mp="188c8vfp1czf5">My Dashboard</p>
        <p className="mt-1 text-sm text-white/60" data-id="element-1049" data-mp="136wozqylgyyc">Your citizen dashboard</p>
      </div>

      <nav className="px-3 pb-8" data-id="element-1050" data-mp="y9mo9f5r90v7">
        <ul data-id="element-1051" data-mp="yao1nqa8tzg3">
          {espaceNav.slice(0, 3).map(item => <li key={item.id} data-id="element-1052" data-mp="u7rq2jj4f3ln">
              <SidebarLink item={item} active={item.id === activeId} data-id="element-1053" data-mp="u8knuv03qirn" />
            </li>)}
        </ul>

        <hr className="my-4 border-white/15" data-id="element-1054" data-mp="1qwr126b3ajhj" />

        <ul data-id="element-1055" data-mp="1lyfq1s9262xq">
          {espaceNav.slice(3).map(item => <li key={item.id} data-id="element-1056" data-mp="1lyph7j5uag50">
              <SidebarLink item={item} active={item.id === activeId} data-id="element-1057" data-mp="1m0idq5mqnjza" />
            </li>)}
        </ul>
      </nav>

      <button type="button" onClick={leave} className="mt-auto flex items-center gap-2 px-7 pb-8 text-sm font-semibold text-white/60 transition-colors duration-150 ease-ville hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-1058" data-mp="1d5u7od9c9y9f">
        <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-1059" data-mp="24vgyxo5qgn6y" />
        Leave my dashboard
      </button>
    </aside>;
}
function SidebarLink({
  item,
  active
}: {
  item: EspaceNavItem;
  active: boolean;
}) {
  const Icon = icons[item.icon];
  return <Link to={item.to} aria-current={active ? 'page' : undefined} className={`flex items-center gap-3.5 rounded-xl px-4 py-3 text-[15px] font-semibold transition-colors duration-150 ease-ville focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${active ? 'bg-white/10 text-white' : 'text-white/75 hover:bg-white/5 hover:text-white'}`} data-id="element-1060" data-mp="3pfc7kryor5zn">
      <Icon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-1061" data-mp="3lf21zget2hlb" />
      {item.label}
    </Link>;
}